import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getAllOrganizedUnitsAcceptClients from '../../services/organizedUnit/getAllOrganizedUnitsAcceptClients'
import messageModalActions from '../../actions/modals/messageModal'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import { showLoader, hideLoader } from '../../actions/common'

export function * fetchOrganizedUnitsAcceptClientsCombo () {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const UOAcceptClientsCombo = yield call(getAllOrganizedUnitsAcceptClients, auth.token)
    yield put(fetchCombosSuccess({ UOAcceptClientsCombo }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchOrganizedUnitsAcceptClientsCombo () {
  yield takeLatest(combosActionTypes.FETCH_ORGANIZED_UNITS_ACCEPT_CLIENTS_COMBO, fetchOrganizedUnitsAcceptClientsCombo)
}
